// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.dl-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 20px;
}
@media only screen and (min-width: 768px) {
  .dl-modal {
    padding-left: 240px;
  }
}
.dl-modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}
.dl-modal__card {
  position: relative;
  z-index: 1;
  width: min(500px, 100%);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.dl-modal__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  background: linear-gradient(135deg, #f1f1f2, #ececed);
  border-bottom: 1px solid #e7eaec;
}
.dl-modal__header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgb(105, 190, 40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.dl-modal__title {
  font-size: 16px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 1.3;
}
.dl-modal__subtitle {
  font-size: 12px;
  color: #676a6c;
  margin: 2px 0 0;
  line-height: 1.3;
  opacity: 0.7;
}
.dl-modal__close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ccc;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.dl-modal__close:hover {
  background: #f1f1f2;
  color: #6d6e71;
  border-color: #ccc;
}
.dl-modal__body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dl-step {
  display: flex;
  gap: 14px;
}
.dl-step__badge {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgb(105, 190, 40);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}
.dl-step--completed .dl-step__badge {
  background: rgb(105, 190, 40);
  opacity: 0.5;
}
.dl-step--disabled .dl-step__badge {
  background: #ccc;
  opacity: 0.4;
}
.dl-step--active .dl-step__badge {
  background: rgb(0, 173, 208);
  opacity: 1;
}
.dl-step__content {
  flex: 1;
  min-width: 0;
}
.dl-step__label {
  font-size: 14px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.dl-step--disabled .dl-step__label {
  color: #ccc;
}
.dl-step__placeholder {
  font-size: 13px;
  color: #ccc;
  font-style: italic;
  padding: 10px 0;
}
.dl-step__action {
  padding-top: 14px;
  border-top: 1px solid #e7eaec;
  margin-top: 4px;
}
.dl-step__info {
  position: relative;
  color: #ccc;
  cursor: pointer;
  font-size: 13px;
}
.dl-step__info:hover {
  color: rgb(0, 173, 208);
}
.dl-step__info:hover .dl-step__info-popup {
  display: block;
}
.dl-step__info-popup {
  display: none;
  position: absolute;
  bottom: calc(100% + 8px);
  right: -20px;
  z-index: 10;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 8px;
  width: 260px;
}
.dl-step__info-popup img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
.dl-step__result-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: rgba(105, 190, 40, 0.04);
  border: 1px solid rgba(105, 190, 40, 0.15);
  border-radius: 8px;
}
.dl-step__result-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(245, 67, 89, 0.1);
  color: rgb(245, 67, 89);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}
.dl-step__result-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.dl-step__result-name {
  font-size: 13px;
  font-weight: 600;
  color: #6d6e71;
}
.dl-step__result-hint {
  font-size: 11px;
  color: #ccc;
  margin-top: 1px;
}

.dl-options {
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  overflow: hidden;
}
.dl-options__group {
  padding: 12px 14px;
  border-bottom: 1px solid #e7eaec;
}
.dl-options__group:last-child {
  border-bottom: none;
}
.dl-options__group-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin-bottom: 8px;
}
.dl-options__radio {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  cursor: pointer;
  padding: 5px 0;
  margin: 0;
  font-size: 13px;
  transition: color 0.12s ease;
}
.dl-options__radio:hover {
  color: rgb(0, 173, 208);
}
.dl-options__radio:hover .dl-options__radio-mark {
  border-color: rgb(105, 190, 40);
}
.dl-options__radio input[type=radio] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.dl-options__radio-mark {
  width: 16px;
  height: 16px;
  border: 2px solid #e7eaec;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  transition: all 0.15s ease;
}
input:checked + .dl-options__radio-mark {
  border-color: rgb(105, 190, 40);
  background: rgb(105, 190, 40);
}
input:checked + .dl-options__radio-mark::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
}
.dl-options__radio-text {
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.dl-options__radio-hint {
  display: block;
  font-size: 11px;
  color: #aaa;
  margin-left: 24px;
  margin-top: -2px;
  line-height: 1.4;
}
.dl-options__info {
  margin-top: 8px;
  padding: 8px 12px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 6px;
  font-size: 12px;
  color: #6d6e71;
  line-height: 1.5;
}
.dl-options__info .fa-info-circle {
  color: #f9a825;
  margin-right: 6px;
}

.dl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.dl-btn i {
  font-size: 12px;
}
.dl-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
}
.dl-btn--primary:hover {
  background: #569c21;
  color: #fff;
}
.dl-btn--success {
  background: rgb(0, 173, 208);
  color: #fff;
  flex-shrink: 0;
}
.dl-btn--success:hover {
  background: #008ba7;
  color: #fff;
}

.dl-options__select select {
  width: 100%;
  padding: 8px 12px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.dl-options__select select:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/dialogbox/dialogbox.component.scss","webpack://./src/app/components/org-individual-teams/download-team-graph/download-team-graph.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AD/QA;EACE,eAAA;ACkRF;;AD/QA;EACE,aAAA;EACA,eAAA;ACkRF;;AD/QA;EACE,sBAAA;ACkRF;;AD/QA;EACE,8BAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,aAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;ADpQE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACuQJ;ADrQI;;;;;;EACE,gBAAA;AC4QN;ADxQE;;EAEE,eA5GO;EA6GP,gBA3GO;ACqXX;ADxQI;EALF;;IAMI,eA/GY;EC2XhB;AACF;ADzQE;;EAEE,eAlHO;EAmHP,gBAjHO;AC4XX;ADzQI;EALF;;IAMI,eArHY;ECkYhB;AACF;AD1QE;;EAEE,eAxHO;EAyHP,gBAvHO;ACmYX;AD1QI;EALF;;IAMI,eA3HY;ECyYhB;AACF;AD3QE;;EAEE,eA9HO;EA+HP,gBA7HO;AC0YX;AD1QE;;EAEE,eAhIO;EAiIP,gBAhIO;AC4YX;ADzQE;;EAEE,eAnIO;EAoIP,gBAnIO;AC8YX;ADrQE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACuQJ;ADrQI;EACE,gBAAA;ACuQN;ADpQI;EAXF;IAYI,eAAA;ECuQJ;AACF;ADpQE;;EAEE,UAAA;EACA,SAAA;ACsQJ;ADnQE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ACqQJ;;ADjQA;EACE,sBAxNQ;AC4dV;;ADjQA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ACoQF;ADlQE;EALF;IAMI,cAAA;ECqQF;AACF;ADnQE;EACE,iBA1Ka;AC+ajB;ADlQE;EACE,gBApLa;EAqLb,WAAA;ACoQJ;;AD/PE;EACE,kBAAA;ACkQJ;AD/PE;EACE,iBAAA;ACiQJ;;AD5PE;EACE,aAAA;AC+PJ;;AD3PA;EACE,kBAAA;AC8PF;AD5PE;EACE,mBAAA;AC8PJ;AD1PI;EACE,sBAAA;AC4PN;ADxPE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACwdnB;ADxPI;EACE,sBAAA;AC0PN;ADvPI;EAVF;IAWI,eApOoB;EC8dxB;AACF;ADvPE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACyPJ;ADvPI;EACE,sBAAA;ACyPN;ADtPI;EACE,WAAA;ACwPN;ADrPI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACmlBZ;;ADlPA;EACE,mBA1PO;AC+eT;ADnPE;EAHF;IAII,mBAAA;ECsPF;AACF;ADpPE;EACE,mBAAA;ACsPJ;ADnPE;EACE,aArQK;AC0fT;ADnPI;EAHF;IAII,aAAA;ECsPJ;AACF;ADpPI;EACE,aAAA;ACsPN;;ADjPA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ACoPF;ADlPE;EACE,eAAA;ACoPJ;ADjPE;EACE,sCAAA;ACmPJ;ADhPE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ACkPJ;;ADnOE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ACsOJ;ADpOI;EACE,kBAAA;ACsON;ADnOI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ACqON;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,+BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ACmOF;ADjOE;EACE,2BAAA;EACA,mBAAA;ACmOJ;ADhOE;EACE,yBAzbiB;EA0bjB,WA1aO;AC4oBX;AD/NE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACiOJ;AD9NE;EACE,yBAjckB;EAkclB,cArciB;ACqqBrB;AD7NE;EACE,yBAvbS;EAwbT,WA1bO;ACypBX;AD7NI;EACE,6BAAA;AC+NN;;AD1NA;EACE;IACE,uBAAA;EC6NF;ED1NA;IACE,yBAAA;EC4NF;AACF;ADzNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,+BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,qBAAA;AC2NF;;ADxNA;EACE,UAAA;AC2NF;ADzNE;EACE,qBAAA;AC2NJ;;ADvNA;EACE,UAAA;AC0NF;;ADtNE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACwNJ;ADrNM;EACE,mBAAA;ACuNR;ADlNE;EACE,2BAAA;ACoNJ;ADjNE;EACE,uBAAA;ACmNJ;ADhNE;EACE,mBAAA;ACkNJ;;AD7ME;EACE,mBAAA;ACgNJ;AD7ME;EACE,yBAAA;AC+MJ;AD5ME;EACE,sBAAA;AC8MJ;AD3ME;EACE,uBAAA;AC6MJ;AD1ME;EACE,oBAAA;AC4MJ;;AC5xBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AD+xBJ;AC7xBI;EAZJ;IAaQ,mBAAA;EDgyBN;AACF;AC9xBI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,UAAA;ADgyBR;AC7xBI;EACI,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0EAAA;EACA,gBAAA;AD+xBR;AC3xBI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qDAAA;EACA,gCAAA;AD6xBR;AC1xBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BF9BQ;EE+BR,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AD4xBR;ACzxBI;EACI,eAAA;EACA,gBAAA;EACA,cFzBa;EE0Bb,wEFlEK;EEmEL,SAAA;EACA,gBAAA;AD2xBR;ACxxBI;EACI,eAAA;EACA,cFtCa;EEuCb,eAAA;EACA,gBAAA;EACA,YAAA;AD0xBR;ACvxBI;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WFjDY;EEkDZ,0BAAA;EACA,cAAA;ADyxBR;ACvxBQ;EACI,mBFrDU;EEsDV,cFzDS;EE0DT,kBFxDQ;ACi1BpB;ACpxBI;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ADsxBR;;AChxBA;EACI,aAAA;EACA,SAAA;ADmxBJ;ACjxBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BFlGQ;EEmGR,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;ADmxBR;AChxBI;EACI,6BF9GQ;EE+GR,YAAA;ADkxBR;AC/wBI;EACI,gBFhGY;EEiGZ,YAAA;ADixBR;AC9wBI;EACI,4BF1HQ;EE2HR,UAAA;ADgxBR;AC7wBI;EACI,OAAA;EACA,YAAA;AD+wBR;AC5wBI;EACI,eAAA;EACA,gBAAA;EACA,cFnHa;EEoHb,wEF5JK;EE6JL,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AD8wBR;AC3wBI;EACI,WF1HY;ACu4BpB;AC1wBI;EACI,eAAA;EACA,WF/HY;EEgIZ,kBAAA;EACA,eAAA;AD4wBR;ACzwBI;EACI,iBAAA;EACA,6BAAA;EACA,eAAA;AD2wBR;ACvwBI;EACI,kBAAA;EACA,WF7IY;EE8IZ,eAAA;EACA,eAAA;ADywBR;ACvwBQ;EACI,uBFvKI;ACg7BhB;ACtwBQ;EACI,cAAA;ADwwBZ;ACpwBI;EACI,aAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,YAAA;ADswBR;ACpwBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;ADswBZ;ACjwBI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,oCAAA;EACA,0CAAA;EACA,kBAAA;ADmwBR;AChwBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,uBFhNU;EEiNV,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;ADkwBR;AC/vBI;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;ADiwBR;AC9vBI;EACI,eAAA;EACA,gBAAA;EACA,cFlNa;ACk9BrB;AC7vBI;EACI,eAAA;EACA,WFrNY;EEsNZ,eAAA;AD+vBR;;ACzvBA;EACI,aAAA;EACA,sBAAA;EACA,MAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AD4vBJ;AC1vBI;EACI,kBAAA;EACA,gCAAA;AD4vBR;AC1vBQ;EACI,mBAAA;AD4vBZ;ACxvBI;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cFpPa;EEqPb,kBAAA;AD0vBR;ACvvBI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,4BAAA;ADyvBR;ACvvBQ;EACI,uBFvRI;ACghChB;ACvvBY;EACI,+BFxRA;ACihChB;ACrvBQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;ADuvBZ;ACnvBI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;ADqvBR;ACnvBQ;EACI,+BF9SI;EE+SJ,6BF/SI;ACoiChB;ACnvBY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;ADqvBhB;AChvBI;EACI,cFpTa;EEqTb,wEFxVK;AC0kCb;AC/uBI;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;ADivBR;AC9uBI;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;ADgvBR;AC9uBQ;EACI,cAAA;EACA,iBAAA;ADgvBZ;;ACzuBA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEF/XS;EEgYT,YAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;EACA,mBAAA;AD4uBJ;AC1uBI;EAAI,eAAA;AD6uBR;AC3uBI;EACI,6BFnXQ;EEoXR,WAAA;AD6uBR;AC3uBQ;EACI,mBAAA;EACA,WAAA;AD6uBZ;ACzuBI;EACI,4BF/XQ;EEgYR,WAAA;EACA,cAAA;AD2uBR;ACzuBQ;EACI,mBAAA;EACA,WAAA;AD2uBZ;;AAjoCI;EACI,WAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wEDVK;ECWL,cDwBa;ECvBb,gBAAA;EACA,aAAA;EACA,wDAAA;EACA,eAAA;AAooCR;AAloCQ;EACI,8BDGI;ECFJ,4CAAA;AAooCZ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n@import './../org-individual-teams/download-team-graph/download-team-graph.component.scss';\n\n// Language select styling within dl-options\n.dl-options__select {\n    select {\n        width: 100%;\n        padding: 8px 12px;\n        font-size: 13px;\n        border: 1px solid $color-grey-1;\n        border-radius: 6px;\n        font-family: $font-stack;\n        color: $body-content-color;\n        background: #fff;\n        outline: none;\n        transition: border-color 0.2s ease, box-shadow 0.2s ease;\n        cursor: pointer;\n\n        &:focus {\n            border-color: $clarify-color;\n            box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n        }\n    }\n}\n","@import './../../../../assets/styles/variables';\n\n// ── Download Modal ──\n\n.dl-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 99999;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    padding: 50px 20px;\n\n    @media #{$mobile-up} {\n        padding-left: 240px;\n    }\n\n    &__overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.45);\n        z-index: 0;\n    }\n\n    &__card {\n        position: relative;\n        z-index: 1;\n        width: min(500px, 100%);\n        background: #fff;\n        border-radius: 12px;\n        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);\n        overflow: hidden;\n    }\n\n    // ── Header ──\n    &__header {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 18px 20px;\n        background: linear-gradient(135deg, $color-neutral-light, darken($color-neutral-light, 2%));\n        border-bottom: 1px solid $color-grey-1;\n    }\n\n    &__header-icon {\n        width: 36px;\n        height: 36px;\n        border-radius: 8px;\n        background: $develop-color;\n        color: #fff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        flex-shrink: 0;\n    }\n\n    &__title {\n        font-size: 16px;\n        font-weight: 700;\n        color: $color-neutral-dark;\n        font-family: $font-stack;\n        margin: 0;\n        line-height: 1.3;\n    }\n\n    &__subtitle {\n        font-size: 12px;\n        color: $body-content-color;\n        margin: 2px 0 0;\n        line-height: 1.3;\n        opacity: 0.7;\n    }\n\n    &__close {\n        margin-left: auto;\n        width: 30px;\n        height: 30px;\n        border: 1px solid $color-grey-1;\n        border-radius: 6px;\n        background: #fff;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 13px;\n        color: $color-neutral-mid;\n        transition: all 0.15s ease;\n        flex-shrink: 0;\n\n        &:hover {\n            background: $color-neutral-light;\n            color: $color-neutral-dark;\n            border-color: $color-neutral-mid;\n        }\n    }\n\n    // ── Body ──\n    &__body {\n        padding: 20px;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n}\n\n// ── Steps ──\n\n.dl-step {\n    display: flex;\n    gap: 14px;\n\n    &__badge {\n        width: 26px;\n        height: 26px;\n        border-radius: 50%;\n        background: $develop-color;\n        color: #fff;\n        font-size: 12px;\n        font-weight: 700;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        margin-top: 1px;\n    }\n\n    &--completed .dl-step__badge {\n        background: $develop-color;\n        opacity: 0.5;\n    }\n\n    &--disabled .dl-step__badge {\n        background: $color-neutral-mid;\n        opacity: 0.4;\n    }\n\n    &--active .dl-step__badge {\n        background: $clarify-color;\n        opacity: 1;\n    }\n\n    &__content {\n        flex: 1;\n        min-width: 0;\n    }\n\n    &__label {\n        font-size: 14px;\n        font-weight: 700;\n        color: $color-neutral-dark;\n        font-family: $font-stack;\n        margin-bottom: 12px;\n        display: flex;\n        align-items: center;\n        gap: 6px;\n    }\n\n    &--disabled .dl-step__label {\n        color: $color-neutral-mid;\n    }\n\n    &__placeholder {\n        font-size: 13px;\n        color: $color-neutral-mid;\n        font-style: italic;\n        padding: 10px 0;\n    }\n\n    &__action {\n        padding-top: 14px;\n        border-top: 1px solid $color-grey-1;\n        margin-top: 4px;\n    }\n\n    // ── Info tooltip ──\n    &__info {\n        position: relative;\n        color: $color-neutral-mid;\n        cursor: pointer;\n        font-size: 13px;\n\n        &:hover {\n            color: $clarify-color;\n        }\n\n        &:hover .dl-step__info-popup {\n            display: block;\n        }\n    }\n\n    &__info-popup {\n        display: none;\n        position: absolute;\n        bottom: calc(100% + 8px);\n        right: -20px;\n        z-index: 10;\n        background: #fff;\n        border: 1px solid $color-grey-1;\n        border-radius: 8px;\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n        padding: 8px;\n        width: 260px;\n\n        img {\n            width: 100%;\n            height: auto;\n            border-radius: 4px;\n        }\n    }\n\n    // ── Result card ──\n    &__result-card {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 14px;\n        background: rgba($develop-color, 0.04);\n        border: 1px solid rgba($develop-color, 0.15);\n        border-radius: 8px;\n    }\n\n    &__result-icon {\n        width: 36px;\n        height: 36px;\n        border-radius: 8px;\n        background: rgba($implement-color, 0.1);\n        color: $implement-color;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 16px;\n        flex-shrink: 0;\n    }\n\n    &__result-info {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        min-width: 0;\n    }\n\n    &__result-name {\n        font-size: 13px;\n        font-weight: 600;\n        color: $color-neutral-dark;\n    }\n\n    &__result-hint {\n        font-size: 11px;\n        color: $color-neutral-mid;\n        margin-top: 1px;\n    }\n}\n\n// ── Options ──\n\n.dl-options {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    border: 1px solid $color-grey-1;\n    border-radius: 8px;\n    overflow: hidden;\n\n    &__group {\n        padding: 12px 14px;\n        border-bottom: 1px solid $color-grey-1;\n\n        &:last-child {\n            border-bottom: none;\n        }\n    }\n\n    &__group-title {\n        font-size: 12px;\n        font-weight: 700;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        color: $color-neutral-dark;\n        margin-bottom: 8px;\n    }\n\n    &__radio {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 8px;\n        cursor: pointer;\n        padding: 5px 0;\n        margin: 0;\n        font-size: 13px;\n        transition: color 0.12s ease;\n\n        &:hover {\n            color: $clarify-color;\n\n            .dl-options__radio-mark {\n                border-color: $develop-color;\n            }\n        }\n\n        input[type=\"radio\"] {\n            position: absolute;\n            opacity: 0;\n            width: 0;\n            height: 0;\n        }\n    }\n\n    &__radio-mark {\n        width: 16px;\n        height: 16px;\n        border: 2px solid $color-grey-1;\n        border-radius: 50%;\n        flex-shrink: 0;\n        position: relative;\n        transition: all 0.15s ease;\n\n        input:checked + & {\n            border-color: $develop-color;\n            background: $develop-color;\n\n            &::after {\n                content: '';\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                width: 6px;\n                height: 6px;\n                border-radius: 50%;\n                background: #fff;\n            }\n        }\n    }\n\n    &__radio-text {\n        color: $body-content-color;\n        font-family: $font-stack;\n    }\n\n    &__radio-hint {\n        display: block;\n        font-size: 11px;\n        color: #aaa;\n        margin-left: 24px;\n        margin-top: -2px;\n        line-height: 1.4;\n    }\n\n    &__info {\n        margin-top: 8px;\n        padding: 8px 12px;\n        background: #fff8e1;\n        border: 1px solid #ffe082;\n        border-radius: 6px;\n        font-size: 12px;\n        color: #6d6e71;\n        line-height: 1.5;\n\n        .fa-info-circle {\n            color: #f9a825;\n            margin-right: 6px;\n        }\n    }\n}\n\n// ── Buttons ──\n\n.dl-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 8px 20px;\n    font-size: 13px;\n    font-weight: 600;\n    font-family: $font-stack;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    text-decoration: none;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n\n    i { font-size: 12px; }\n\n    &--primary {\n        background: $develop-color;\n        color: #fff;\n\n        &:hover {\n            background: darken($develop-color, 8%);\n            color: #fff;\n        }\n    }\n\n    &--success {\n        background: $clarify-color;\n        color: #fff;\n        flex-shrink: 0;\n\n        &:hover {\n            background: darken($clarify-color, 8%);\n            color: #fff;\n        }\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
